<template>
  <hm-content title>
    <div class="table-panel flex flex-between">
      <el-button type="primary" size="small" @click="add">新增</el-button>
      <div>
        <el-input
          clearable
          v-model.trim="searchCondition.keyWords"
          placeholder="请输入编码/名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <el-table
      stripe
      border
      ref="table"
      :data="list"
      style="width: 100%"
      id="table"
      size="small"
    >
      <el-table-column
        type="index"
        label="序号"
        header-align="center"
        align="center"
        :index="index => index + (currentPage - 1) * pageSize + 1"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="reportCode"
        label="编码"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="reportName"
        label="名称"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="remark"
        label="说明"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="sysCategoryFullName"
        label="分类"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="enabledState"
        label="状态"
      >
        <template slot-scope="scope">{{
          scope.row.enabledState === "yes" ? "开启" : "关闭"
        }}</template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="isPublished"
        label="发布状态"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.isPublished === 'published'" class="success">
            {{ scope.row.publishedName }}
          </div>
          <div
            v-else-if="scope.row.isPublished === 'edit'"
            class="danger"
          ></div>
          <div v-else class="blue">
            {{ scope.row.publishedName }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        header-align="center"
        align="center"
        width="200"
      >
        <template slot-scope="scope">
          <el-button size="small" type="text" @click="toReportTemp(scope.row)"
            >可视化</el-button
          >
          <el-button size="small" type="text" @click="copy(scope.row)"
            >复制</el-button
          >
          <el-button size="small" type="text" @click="edit(scope.row)"
            >编辑</el-button
          >
          <el-button size="small" type="text" @click="authorization(scope.row)"
            >授权</el-button
          >
          <el-button
            size="small"
            type="text"
            @click="template(scope.row)"
            v-if="scope.row.emailNotice === 'template'"
            >模板</el-button
          >
          <el-button size="small" type="text" @click="details(scope.row)"
            >查看</el-button
          >
          <el-button size="small" type="text" @click="issue(scope.row)"
            >发布</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="total"
        @current-change="paging"
        :page-size="pageSize"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      width="1500px"
      :before-close="cancel"
      :visible.sync="dialogVisible"
    >
      <div>1.基本信息</div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="150px"
      >
        <el-form-item label="分类" prop="sysCategoryId">
          <el-cascader
            style="width:600px"
            :disabled="type === 'details'"
            v-model="ruleForm.sysCategoryId"
            :show-all-levels="true"
            size="small"
            class="mr10"
            :props="sysProps"
            :options="options"
            clearable
            placeholder="请选择分类"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="编码" prop="reportCode">
          <el-input
            :disabled="type === 'details'"
            style="width:600px"
            size="small"
            clearable
            class="mr10 ipt"
            v-model.trim="ruleForm.reportCode"
            placeholder="请输入编码"
          ></el-input>
        </el-form-item>
        <el-form-item label="名称" prop="reportName">
          <el-input
            :disabled="type === 'details'"
            style="width:600px"
            size="small"
            clearable
            class="mr10 ipt"
            v-model.trim="ruleForm.reportName"
            placeholder="请输入名称"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="应用类型"
          :prop="type === 'add' ? 'reportType' : ''"
        >
          <el-select
            :disabled="type !== 'add'"
            size="small"
            v-model="ruleForm.reportType"
            class="mr10"
            filterable
            @change="reportTypeChange"
          >
            <el-option
              v-for="(item, i) in dataReportTypeList"
              :key="i"
              :label="item.itemText"
              :value="item.itemValue"
            ></el-option>
          </el-select>
          <div class="form-item-tip red">{{paramValue}}</div>
        </el-form-item>

        <template v-if="ruleForm.reportType !== 'template'">
          <el-form-item label="数据源" prop="datasourceId">
            <el-select
              size="small"
              v-model="ruleForm.datasourceId"
              class="mr10"
              filterable
              @change="updateDatasourceId"
              :disabled="type === 'details'"
            >
              <el-option
                v-for="(item, i) in dataSoureceList"
                :key="i"
                :label="item.itemText"
                :value="item.itemValue"
              ></el-option>
            </el-select>
          </el-form-item>

          <!-- <el-form-item label="发布状态" prop="isPublished">
            <el-select
            size="small"
            clearable
            placeholder="请选择类型"
            v-model="ruleForm.isPublished"
            class="mr10"
            filterable
            :disabled="type === 'details'"
          >
            <el-option
              v-for="(item, i) in $sysAllDict.ssr_is_published"
              :key="i"
              :label="item.text"
              :value="item.value"
              v-if="item.value!=='published'"
            ></el-option>
            </el-select>
        </el-form-item> -->
          <el-form-item label="SQL解析器版本" prop="sqlParseVersion">
            <el-select
              size="small"
              clearable
              placeholder="请选择SQL解析器版本"
              v-model="ruleForm.sqlParseVersion"
              class="mr10"
              filterable
              :disabled="type === 'details'"
              @change="sqlParseVersionChange"
            >
              <el-option
                v-for="(item, i) in sqlParseVersionList"
                :key="i"
                :label="item.itemText"
                :value="item.itemValue"
              ></el-option>
            </el-select>
            <el-select
              size="small"
              clearable
              placeholder="请选择"
              v-model="ruleForm.elasticsearchDslVersion"
              class="mr10"
              filterable
              :disabled="type === 'details'"
              v-if="ruleForm.sqlParseVersion === 'elasticsearchDSLParse'"
            >
              <el-option
                v-for="(item, i) in dslList"
                :key="i"
                :label="item.itemText"
                :value="item.itemValue"
              ></el-option>
            </el-select>
            <!-- <el-cascader
            style="width:600px"
            :disabled="type === 'details'"
            v-model="ruleForm.sysCategoryId"
            :show-all-levels="false"
            size="small"
            class="mr10"
            :props="sysProps"
            :options="options"
            clearable
            placeholder="请选择分类"
          ></el-cascader>-->
          </el-form-item>
          <el-form-item label="索引名称" prop="targetIndexName" v-if="ruleForm.datasourceId.includes('bbossEsStarter')">
            <el-select
              style="width:600px"
              size="small"
              clearable
              placeholder="请输入索引名称"
              v-model="ruleForm.targetIndexName"
              class="mr10"
              filterable
              remote
              :remote-method="remoteMethod"
              :disabled="type === 'details'"
            >
              <el-option
                  v-for="(item) in targetIndexNameList"
                  :key="item.indexPrefixName"
                  :label="item.label"
                  :value="item.indexPrefixName"
              ></el-option>
            </el-select>
            <el-input
              style="width:100px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleForm.targetIndexNameInput"
              :disabled="type === 'details'"
            ></el-input>
            <el-button
              size="small"
              type="primary"
              @click="sync()"
              >同步</el-button
            >
          </el-form-item>  
          <el-form-item label="目标字段key" prop="targetFieldKey">
            <el-input
              style="width:600px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleForm.targetFieldKey"
              :disabled="type === 'details'"
            ></el-input>
            <div class="form-item-tip red">
              （宽表子数据,以List结尾直接以该key名称存列表结构，以OneData结尾替换OneData存第一条数据，不接受其他后缀key。）
            </div>
          </el-form-item>          
          <el-form-item label="邮件标题" prop="emailTitle" v-if="ruleForm.reportType === 'emailNotice'">
            <el-input
              :disabled="type === 'details'"
              style="width:600px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleForm.emailTitle"
              placeholder="请输入邮件标题"
            ></el-input>
          </el-form-item>
          <el-form-item label="邮件内容" prop="emailContent" v-if="ruleForm.reportType === 'emailNotice'">
            <el-input
              :disabled="type === 'details'"
              style="width:600px"
              size="small"
              clearable
              class="mr10 ipt"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4 }"
              v-model.trim="ruleForm.emailContent"
              placeholder="请输入邮件内容"
            ></el-input>
          </el-form-item>
          <el-form-item label="功能编码" prop="funcCode" v-if="ruleForm.reportType === 'emailNotice'">
            <el-input
              :disabled="type === 'details'"
              style="width:600px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleForm.funcCode"
              placeholder="请输入功能编码"
            ></el-input>
          </el-form-item>
          <el-form-item label="检查时间类型" prop="checkTimeType" v-if="ruleForm.reportType === 'emailNotice'">
            <el-select
              size="small"
              clearable
              placeholder="请选择检查时间类型"
              v-model="ruleForm.checkTimeType"
              class="mr10"
              filterable
              :disabled="type === 'details'"
            >
              <el-option
                v-for="(item, i) in checkTimeTypeList"
                :key="i"
                :label="item.itemText"
                :value="item.itemValue"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="检查时间范围" prop="checkTimeRange" v-if="ruleForm.reportType === 'emailNotice'">
            <el-input
              :disabled="type === 'details'"
              style="width:600px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleForm.checkTimeRange"
              placeholder="请输入检查时间范围"
            ></el-input>
          </el-form-item>
          <el-form-item label="通知时间范围" prop="noticeTimeRange" v-if="ruleForm.reportType === 'emailNotice'">
            <el-input
              :disabled="type === 'details'"
              style="width:600px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleForm.noticeTimeRange"
              placeholder="请输入通知时间范围"
            ></el-input>
          </el-form-item>          
          <el-form-item label="基础SQL" prop="sqlContent">
            <el-input
              :disabled="type === 'details'"
              style="width:1200px"
              size="small"
              clearable
              class="mr10 ipt"
              type="textarea"
              :autosize="{ minRows: 15, maxRows: 17 }"
              v-model="ruleForm.sqlContent"
              placeholder="请输入基础SQL"
              @change="sqlContentChange"
            ></el-input>
            <div class="form-item-tip">要单表查询或连表查询的语句（form）</div>
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="截存表" prop="tableName">
            <el-select
              size="small"
              v-model="ruleForm.tableName"
              class="mr10"
              filterable
              :disabled="type !== 'add'"
            >
              <el-option
                v-for="(item, i) in specialTableList"
                :key="i"
                :label="item.tableComment"
                :value="item.tableName"
              ></el-option>
            </el-select>
            <el-button
              type="primary"
              size="small"
              @click="searchData"
              v-if="type === 'add'"
              :disabled="!ruleForm.tableName"
              >确认数据源，导入字段</el-button
            >
          </el-form-item>
        </template>
        <el-form-item label="字段配置" prop="ssrColumnsConfigModelList">
          <div class="flex flex-start item-center mt10">
            <el-button
              size="small"
              type="primary"
              v-if="type !== 'details' && ruleForm.reportType !== 'template'"
              @click="addfield('ssrColumnsConfigModelList')"
              >添加</el-button
            >
          </div>
          <div>
            <el-table
              stripe
              style="width: 100%"
              ref="table"
              id="table"
              border
              size="small"
              :data="ruleForm.ssrColumnsConfigModelList"
              :max-height="400"
            >
              <el-table-column
                header-align="center"
                align="center"
                type="index"
                label="序号"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="列名称"
                prop="labelName"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="对应列字段名"
                prop="columnName"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="关联字典编码"
                prop="associatedDictCode"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="是否表头字段"
                prop="isSelectColumn"
                min-width="65px"
              >
                <template slot-scope="scope">
                  <div class="is-column">
                    <i
                      class="el-icon-check success"
                      v-if="scope.row.isSelectColumn === 'yes'"
                    ></i>
                    <i
                      class="el-icon-close danger"
                      v-if="scope.row.isSelectColumn === 'no'"
                    ></i>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="表头顺序"
                prop="selectSeqNum"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="是否查询字段"
                prop="isWhereColumn"
                min-width="65px"
              >
                <template slot-scope="scope">
                  <div class="is-column">
                    <i
                      class="el-icon-check success"
                      v-if="scope.row.isWhereColumn === 'yes'"
                    ></i>
                    <i
                      class="el-icon-close danger"
                      v-if="scope.row.isWhereColumn === 'no'"
                    ></i>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="字段类型"
                prop="columnTypeName"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="查询模式"
                prop="queryModeName"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="是否必填"
                prop="isRequiredWhere"
                min-width="50px"
              >
                <template slot-scope="scope">
                  <div class="is-column">
                    <i
                      class="el-icon-check success"
                      v-if="scope.row.isRequiredWhere === 'yes'"
                    ></i>
                    <i
                      class="el-icon-close danger"
                      v-if="scope.row.isRequiredWhere === 'no'"
                    ></i>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="查询分组序号"
                prop="whereGroupNum"
                min-width="65px"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="查询顺序"
                prop="whereSeqNum"
                min-width="50px"
              ></el-table-column>

              <el-table-column
                header-align="center"
                align="center"
                label="日期时间范围限制（天）"
                prop="datetimeRangeLimit"
              ></el-table-column>

              <el-table-column
                header-align="center"
                align="center"
                label="是否分组字段"
                prop="isGroupColumn"
                min-width="65px"
              >
                <template slot-scope="scope">
                  <div class="is-column">
                    <i
                      class="el-icon-check success"
                      v-if="scope.row.isGroupColumn === 'yes'"
                    ></i>
                    <i
                      class="el-icon-close danger"
                      v-if="scope.row.isGroupColumn === 'no'"
                    ></i>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="分组顺序"
                prop="groupSeqNum"
                min-width="50px"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="是否聚合字段"
                prop="isAggregateColumn"
                min-width="65px"
              >
                <template slot-scope="scope">
                  <div class="is-column">
                    <i
                      class="el-icon-check success"
                      v-if="scope.row.isAggregateColumn === 'yes'"
                    ></i>
                    <i
                      class="el-icon-close danger"
                      v-if="scope.row.isAggregateColumn === 'no'"
                    ></i>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="聚合字段表达式"
                prop="aggregateExpression"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="是否发布"
                prop="isPublished"
              >
                <template slot-scope="scope">
                  <div
                    :class="
                      scope.row.isPublished === 'published' ? 'success' : 'gray'
                    "
                  >
                    {{
                      scope.row.isPublished === "published"
                        ? "已发布"
                        : "未发布"
                    }}
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                header-align="center"
                align="center"
                label="操作"
                v-if="type !== 'details'"
              >
                <template slot-scope="scope">
                  <el-button
                    size="small"
                    type="text"
                    @click="
                      editField('searchFieldList', scope.row, scope.$index)
                    "
                    >编辑</el-button
                  >
                  <div>
                    <el-button
                      size="small"
                      type="text"
                      :disabled="!!scope.row.id"
                      @click="del('ssrColumnsConfigModelList', scope.$index)"
                      >删除</el-button
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
        <el-form-item label="说明" prop="remark">
          <el-input
            :disabled="type === 'details'"
            style="width:400px"
            size="small"
            clearable
            class="mr10 ipt"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            v-model="ruleForm.remark"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
        <el-form-item label="搜集查询值" prop="collectQueryValue">
          <el-switch
            v-model="ruleForm.collectQueryValue"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="是"
            inactive-text="否"
            active-value="yes"
            inactive-value="no"
          >
          </el-switch>
        </el-form-item>  
        <!--
        <el-form-item label="是否发布" prop="isPublished">
          <el-switch
            v-model="ruleForm.isPublished"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="是"
            inactive-text="否"
            active-value="published"
            inactive-value="edit"
          >
          </el-switch>
        </el-form-item>-->
      </el-form>

      <el-dialog
        width="700px"
        :title="innerTitle"
        :visible.sync="innerVisible"
        append-to-body
        :close-on-click-modal="false"
      >
        <el-form
          :model="ruleFormField"
          :rules="rulesField"
          ref="ruleFormField"
          label-width="130px"
        >
          <el-form-item label="列名称" prop="labelName">
            <el-input
              style="width:400px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleFormField.labelName"
              placeholder="请输入列名称"
            ></el-input>
          </el-form-item>

          <el-form-item label="对应列字段名" prop="columnName">
            <el-input
              style="width:400px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleFormField.columnName"
              placeholder="请输入列名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="关联字典编码" prop="associatedDictCode">
            <el-input
              style="width:400px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleFormField.associatedDictCode"
              placeholder="请输入关联字典编码"
            ></el-input>
            <div class="danger" style="line-height:20px;">配置字典编码的字段，SQL查询出来的结果必须是字符串类型。不然前端字典转换会为空。MySql语法：CONVERT(23,CHAR)</div>
          </el-form-item>
          <el-form-item label="字段类型" prop="columnType">
            <el-select
              size="small"
              style="width:400px"
              v-model="ruleFormField.columnType"
              ref="columnType"
              @change="columnTypeChange"
            >
              <el-option
                v-for="(v, i) in columnList"
                :key="i"
                :label="v.itemText"
                :value="v.itemValue"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否表头字段" prop="isSelectColumn">
            <el-radio-group v-model="ruleFormField.isSelectColumn" size="small">
              <el-radio label="yes">
                <i class="el-icon-check success is-column"></i
              ></el-radio>
              <el-radio
                label="no"
                :disabled="
                  ruleFormField.isAggregateColumn === 'yes' ||
                    ruleFormField.isGroupColumn === 'yes'
                "
              >
                <i class="el-icon-close danger is-column"></i
              ></el-radio>
            </el-radio-group>
            <!-- <el-switch
              v-model="ruleFormField.isSelectColumn"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="是"
              inactive-text="否"
              active-value="yes"
              inactive-value="no"
            >
            </el-switch>-->
          </el-form-item>
          <el-form-item
            label="表头顺序"
            prop="selectSeqNum"
            v-if="ruleFormField.isSelectColumn === 'yes'"
          >
            <el-input
              type="number"
              style="width:400px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleFormField.selectSeqNum"
              placeholder="请输入表头顺序"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否查询字段" prop="isWhereColumn">
            <el-radio-group v-model="ruleFormField.isWhereColumn" size="small">
              <el-radio label="yes">
                <i class="el-icon-check success is-column"></i>
              </el-radio>
              <el-radio label="no">
                <i class="el-icon-close danger is-column"></i>
              </el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item
            label="查询模式"
            prop="queryMode"
            v-if="ruleFormField.isWhereColumn === 'yes'"
          >
            <el-select
              size="small"
              style="width:400px"
              v-model="ruleFormField.queryMode"
              ref="queryMode"
            >
              <el-option
                v-for="(v, i) in modeList"
                :key="i"
                :disabled="
                  (v.itemValue === 'range' &&
                    ruleFormField.columnType === 'strings') ||
                    (v.itemValue === 'like' &&
                      ruleFormField.columnType === 'integer') ||
                    (ruleFormField.columnType === 'datetime' &&
                      (v.itemValue === 'single' ||
                        v.itemValue === 'multiple' ||
                        v.itemValue === 'like'))
                "
                :label="v.itemText"
                :value="v.itemValue"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="是否必填"
            prop="isRequiredWhere"
            v-if="ruleFormField.isWhereColumn === 'yes'"
          >
            <el-switch
              v-model="ruleFormField.isRequiredWhere"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="是"
              inactive-text="否"
              active-value="yes"
              inactive-value="no"
            ></el-switch>
          </el-form-item>

          <el-form-item
            label="默认值"
            prop="datetimeRangeType"
            v-if="
              ruleFormField.columnType === 'datetime' &&
                ruleFormField.queryMode === 'range'
            "
          >
            <el-select
              size="small"
              style="width:400px"
              v-model="ruleFormField.datetimeRangeType"
              @change="dateTimeRangeTypeChange"
            >
              <el-option
                v-for="(v, i) in dateTypeList"
                :key="i"
                :label="v.itemText"
                :value="v.itemValue"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="日期时间范围限制"
            prop="datetimeRangeLimit"
            v-if="
              ruleFormField.columnType === 'datetime' &&
                ruleFormField.queryMode === 'range'
            "
          >
            <el-input
              style="width:400px"
              size="small"
              clearable
              class="mr10 ipt"
              @input="filterGt0('datetimeRangeLimit')"
              v-model.trim="ruleFormField.datetimeRangeLimit"
              placeholder="请输入天数"
            ></el-input
            >天
          </el-form-item>
          <el-form-item
            label="查询分组序号"
            prop="whereGroupNum"
            v-if="ruleFormField.isWhereColumn === 'yes'"
          >
            <el-select
              size="small"
              style="width:400px"
              v-model="ruleFormField.whereGroupNum"
            >
              <el-option
                v-for="(v, i) in whereGroupNumList"
                :key="i"
                :label="v"
                :value="v"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="查询顺序"
            prop="whereSeqNum"
            v-if="ruleFormField.isWhereColumn === 'yes'"
          >
            <el-input
              type="number"
              style="width:400px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleFormField.whereSeqNum"
              placeholder="请输入查询顺序"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item
            label="查询方式"
            prop="queryFs"
            v-if="
              ruleFormField.queryMode === 'single' &&
                ruleFormField.columnType !== 'datetime'
            "
          >
            <el-select
              size="small"
              style="width:400px"
              v-model="ruleFormField.queryFs"
              ref="queryFs"
            >
              <el-option label="输入框" value="input"></el-option>
              <el-option label="下拉框" value="select"></el-option>
            </el-select>
          </el-form-item>-->

          <el-form-item label="是否分组字段" prop="isGroupColumn">
            <el-radio-group
              v-model="ruleFormField.isGroupColumn"
              size="small"
              @change="isGroupColumnChange"
            >
              <el-radio
                label="yes"
                :disabled="ruleFormField.isAggregateColumn === 'yes'"
              >
                <i class="el-icon-check success is-column"></i>
              </el-radio>
              <el-radio label="no">
                <i class="el-icon-close danger is-column"></i>
              </el-radio>
            </el-radio-group>
            <!-- <el-switch
              v-model="ruleFormField.isGroupColumn"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="是"
              inactive-text="否"
              active-value="yes"
              inactive-value="no"
            >
            </el-switch>-->
          </el-form-item>
          <el-form-item
            label="分组顺序"
            prop="groupSeqNum"
            v-if="ruleFormField.isGroupColumn === 'yes'"
          >
            <el-input
              type="number"
              style="width:400px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleFormField.groupSeqNum"
              placeholder="请输入分组顺序"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否聚合字段" prop="isAggregateColumn">
            <el-radio-group
              v-model="ruleFormField.isAggregateColumn"
              size="small"
            >
              <el-radio
                label="yes"
                :disabled="ruleFormField.isGroupColumn === 'yes'"
              >
                <i class="el-icon-check success is-column"></i>
              </el-radio>
              <el-radio label="no">
                <i class="el-icon-close danger is-column"></i>
              </el-radio>
            </el-radio-group>
            <!-- <el-switch
              v-model="ruleFormField.isAggregateColumn"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="是"
              inactive-text="否"
              active-value="yes"
              inactive-value="no"
            >
            </el-switch>-->
          </el-form-item>
          <el-form-item
            label="聚合字段表达式"
            prop="aggregateExpression"
            v-if="ruleFormField.isAggregateColumn === 'yes'"
          >
            <el-input
              style="width:400px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleFormField.aggregateExpression"
              placeholder="请输入聚合字段表达式"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="flex flex-center">
          <el-button
            type="primary"
            @click="submitFieldForm('ruleFormField')"
            size="small"
            >确 认</el-button
          >
          <el-button @click="innerVisible = false" size="small"
            >取 消</el-button
          >
        </div>
      </el-dialog>
      <div slot="footer" class="flex flex-center">
        <el-button
          v-if="type !== 'details'"
          type="primary"
          @click="submitRuleForm('ruleForm')"
          size="small"
          >确 认</el-button
        >
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
      </div>
    </el-dialog>
    <el-drawer
      custom-class="hm-drawer"
      :wrapperClosable="false"
      title="角色权限配置"
      :visible="authorizeDialogVisible"
      direction="rtl"
      :before-close="handleClose"
    >
      <div class="drawer-content">
        <el-input
          style="width:230px"
          size="small"
          class="mr10"
          clearable
          placeholder="输入商户名称/商户编码"
          v-model="filterText"
        ></el-input>
        <el-button
          type="primary"
          size="small"
          @click="searchStore"
          :disabled="filterText === ''"
          >查询</el-button
        >
        <div class="caption">所拥有的权限：</div>
        <el-tree
          :data="allStoreNmae"
          empty-text="暂无权限"
          :props="props"
          :check-strictly="checkStrictly"
          node-key="storeCode"
          default-expand-all
          ref="tree"
          show-checkbox
          :render-content="renderContent"
        ></el-tree>
      </div>
      <div class="drawer-footer flex flex-between item-center">
        <div>
          <el-dropdown
            @visible-change="visibleChange"
            trigger="click"
            @command="selectItem"
          >
            <span class="el-dropdown-link flex item-center">
              树操作
              <i class="el-icon-arrow-up el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="checkAll">全部勾选</el-dropdown-item>
              <el-dropdown-item command="cancleCheckAll"
                >取消全选</el-dropdown-item
              >
              <el-dropdown-item command="openAll">展开所有</el-dropdown-item>
              <el-dropdown-item command="cancleOpenAll"
                >合并所有</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div>
          <el-button type="primary" size="small" @click="savePermission"
            >保存</el-button
          >
          <el-button size="small" @click="authorizeDialogVisible = false"
            >返回</el-button
          >
        </div>
      </div>
    </el-drawer>
    <el-dialog
      :close-on-click-modal="false"
      title="角色权限配置"
      width="1300px"
      :visible.sync="authDialogVisible"
    >
      <div class="mb10 flex flex-between">
        <el-button type="primary" size="small" @click="addAuth"
          >新增授权</el-button
        >
        <div>
          <el-input
            clearable
            style="width:250px"
            v-model.trim="storeName"
            placeholder="请输入商户名称"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-button type="primary" size="small" @click="searchAuth"
            >查询</el-button
          >
        </div>
      </div>
      <div>
        <el-table
          :data="hasAuthList"
          style="width: 100%"
          stripe
          border
          size="small"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="index => index + (currentPageAuth - 1) * pageSizeAuth + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="storeName"
            label="商户名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="storeCode"
            label="商户编码"
          ></el-table-column>

          <el-table-column
            label="操作"
            header-align="center"
            align="center"
            width="200"
          >
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="cancelAuth(scope.row)"
                >取消授权</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="totalAuth"
            @current-change="pagingAuth"
            :page-size="pageSizeAuth"
            @size-change="handleSizeChangeAuth"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPageAuth"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>
    <!-- <draggable class="tmplmsg_keywords_selected_list mt20" :list="list">
      <li
        class="flex flex-between tmplmsg_keywords_selected_item"
        v-for="(v, i) in list"
        :key="i"
      >
        <div>{{ v.reportName }}</div>
        <div>
          <span class="hmicon icon-hanbaobao"></span>
        </div>
      </li>
    </draggable>-->
  </hm-content>
</template>

<script>
// import draggable from "vuedraggable";
import { arrayUnique2, getDayAndToday } from "@/utils/utils";
// import { parse } from "path-to-regexp";
export default {
  components: {},
  data() {
    return {
      whereGroupNumList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      storeName: "",
      authDialogVisible: false,
      filterText: "",
      authorizeDialogVisible: false,
      checkStrictly: true,
      props: {
        label: "storeName",
        children: "children"
      },
      dateList: [],
      selectDate: "",
      //日期选择范围在一个月内
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime();
          if (maxDate) {
            this.selectDate = "";
          }
        },
        disabledDate: time => {
          if (this.selectDate !== "") {
            const one = 30 * 24 * 3600 * 1000;
            const minTime = this.selectDate - one;
            const maxTime = this.selectDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        }
      },
      ruleFormField: {
        labelName: "",
        associatedDictCode: "",
        columnName: "",
        columnType: "",
        datetimeRangeLimit: "",
        queryMode: "",
        isGroupColumn: "no",
        isSelectColumn: "no",
        isWhereColumn: "no",
        isAggregateColumn: "no",
        aggregateExpression: "",
        groupSeqNum: "",
        selectSeqNum: "",
        whereSeqNum: "",
        whereGroupNum: "",
        isRequiredWhere: "no",
        datetimeRangeType: ""
      },
      rulesField: {
        labelName: {
          required: true,
          message: "请输入列名称",
          trigger: "blur"
        },
        whereGroupNum: {
          required: true,
          message: "请选择查询分组序号",
          trigger: "blur"
        },
        columnName: [
          {
            required: true,
            message: "请输入列名称",
            trigger: "blur"
          }
          // {
          //   message: "只能输入字母的组合",
          //   pattern: /^[a-zA-Z-_]*$/g,
          //   trigger: "blur"
          // }
        ],
        columnType: {
          required: true,
          message: "请选择字段类型",
          trigger: "blur"
        },
        queryMode: {
          required: true,
          message: "请选择查询模式",
          trigger: "blur"
        },
        aggregateExpression: {
          required: true,
          message: "请输入聚合字段表达式",
          trigger: "blur"
        }
      },
      fieldType: "",
      innerType: "",
      innerVisible: false,
      innerTitle: "",
      dialogVisible: false,
      title: "",
      currentPage: 1,
      pageSize: 10,
      total: 0,
      currentPageAuth: 1,
      pageSizeAuth: 10,
      totalAuth: 0,
      list: [],
      searchCondition: {},
      ruleForm: {
        datasourceId: "",
        reportType: "",
        sysCategoryId: "",
        sqlParseVersion: "",
        tableName: "",
        reportCode: "",
        reportName: "",
        remark: "",
        reportMainType: "sql",
        sqlContent: "",
        ssrColumnsConfigModelList: [],
        isPublished: "",
        collectQueryValue: "no",
        targetIndexName: "",
        emailTitle: "",
        emailContent: "",
        funcCode: "",
        checkTimeType: "daily",
        checkTimeRange: "",
        noticeTimeRange: "",
        targetIndexNameInput: "",
        targetFieldKey: "",
      },
      rules: {
        reportType: {
          required: true,
          message: "请选择应用类型",
          trigger: "change"
        },
        datasourceId: {
          required: true,
          message: "请选择数据源"
        },
        sysCategoryId: {
          required: true,
          message: "请选择分类",
          trigger: "blur"
        },
        sqlParseVersion: {
          required: true,
          message: "请选择SQL解析器版本",
          trigger: "blur"
        },
        targetIndexName: {
          required: true,
          message: "请选择索引名称",
          trigger: "blur"
        },
        reportCode: {
          required: true,
          message: "请输入编码",
          trigger: "blur"
        },
        reportName: {
          required: true,
          message: "请输入名称",
          trigger: "blur"
        },
        remark: [
          {
            required: false,
            message: "请输入拒绝理由",
            trigger: "blur"
          }
        ],
        sqlContent: {
          required: true,
          message: "请输入基础SQL",
          trigger: "blur"
        },
        // ssrColumnsConfigModelList: {
        //   required: true,
        //   message: "请配置显示字段",
        //   trigger: "blur"
        // },
        tableName: {
          required: true,
          message: "请选择截存表",
          trigger: "blur"
        }
      },
      row: {},
      index: 0,
      modeList: [],
      columnList: [],
      type: "",
      listRow: {},
      hasAuthList: [],
      allStoreNmae: [],
      options: [],
      sysProps: {
        value: "key",
        label: "title",
        checkStrictly: true,
        expandTrigger: "hover"
      },
      sqlParseVersionList: [],
      dateTypeList: [],
      dataSoureceList: [],
      dataReportTypeList: [],
      specialTableList: [],
      paramValue: "",
      checkTimeTypeList:[
        {
          itemText: "每日",
          itemValue: "daily",
        }
      ],
      allMerchant:[],
      targetIndexNameList: [],
      dslList: [],
    };
  },
  computed: {},
  watch: {
    ruleFormField: {
      handler(newValue) {
        if (
          newValue.isAggregateColumn === "yes" ||
          newValue.isGroupColumn === "yes"
        ) {
          this.ruleFormField.isSelectColumn = "yes";
        }
      },
      deep: true
    }
    // filterText(val) {
    //   this.$refs.tree.filter(val);
    // }
  },
  created() {
    let str = "SqlServer";
    let text = "SqlServer全权限(慎用)";
    console.log("text.indexOf(str) != -1", text.indexOf(str) != -1);
  },
  mounted() {
    this.queryReportMode();
    this.queryReportColumn();
    this.querySsrDateType();
    // this.getAllStoreCodes();
    this.queryList();
    this.queryTree();
    this.querySqlParseVersion();
    this.queryReportDataSource();
    this.queryReportDataReportType();
    this.querySpecialTable();
    this.getParamValueAllowNull();
    this.queryElasticsearchDslVersion();
  },
  methods: {
    //修改数据源的值
    updateDatasourceId(val) {
      console.log("val", val);
      console.log("datasourceId", this.ruleForm.datasourceId);
      if(val.includes('bbossEsStarter')){
        this.ruleForm.reportMainType = "elasticsearch";
        this.queryAllMerchant();
        this.querySqlParseVersion('bbossEsStarter');
      }else{
        this.ruleForm.reportMainType = "sql";
        this.querySqlParseVersion();
      }
    },
    sqlParseVersionChange(val){
      console.log("val:",val);
    },
    async searchData() {
      let index = this.specialTableList.findIndex(
        v => v.tableName === this.ruleForm.tableName
      );
      if (index < 0) {
        return;
      }
      const { result } = await this.$store.dispatch(
        "queryPageListByTableName",
        this.specialTableList[index]
      );
      this.ruleForm.ssrColumnsConfigModelList = result;
      console.log("result: ", result);
      console.log("index: ", index);
    },
    async querySpecialTable() {
      const { result } = await this.$store.dispatch("querySpecialTable", {
        specialTableName: "rpt",
        pageNo: 1,
        pageSize: 9999
      });
      this.specialTableList = result.records;
    },
    reportTypeChange(val) {
      console.log("val: ", val);
    },
    async queryReportDataReportType() {
      const { result } = await this.$store.dispatch(
        "queryReportDataReportType"
      );
      this.dataReportTypeList = result;
    },
    queryPublishedName(val) {
      this.$sysAllDict.ssr_is_published.forEach(v => {
        if (v.value === val) {
          return v.text;
        }
      });
    },
    async queryReportDataSource() {
      const { result } = await this.$store.dispatch("queryReportDataSource");
      this.dataSoureceList = result;
    },
    dateTimeRangeTypeChange(val) {
      console.log(getDayAndToday(val));
    },
    toReportTemp(row) {
      this.$router.push({
        name: "ReportTemp",
        query: {
          id: row.id
        }
      });
    },
    renderContent(h, { data }) {
      return (
        <div class="el-tree-node__label flex flex-between" style="width:100%">
          <div>{data.storeName}</div>
          <div>{data.storeCode}</div>
        </div>
      );
    },
    async querySqlParseVersion(type) {
      this.ruleForm.sqlParseVersion = "";
      let list = [];
      let url = "";
      if (this.oldSqlParseVersionList && this.oldSqlParseVersionList.length > 0) {
        list = this.oldSqlParseVersionList;
      } else {
        if(type && type === 'bbossEsStarter'){
          url = 'elasticsearchParseVersion'
        }else{
          url = 'sqlParseVersion'
        }
        const { result } = await this.$store.dispatch(url);
        list = result;
      }
      let copyList = JSON.parse(JSON.stringify(list));
      let showMysqlList = [];
      let showSqlServerList = []
      copyList.forEach(v => {
        if (v.itemValue.indexOf("SqlServer") != -1) {
          showSqlServerList.push(v);
        } else {
          showMysqlList.push(v);
        }
      });
      this.sqlParseVersionList = this.ruleForm.datasourceId == "store36040016092873saferead" ? showSqlServerList : showMysqlList;
    },
    async queryTree() {
      let params = {
        pcode: "B03",
        async: false
      };
      const { result } = await this.$store.dispatch("loadTreeRoot", params);
      this.options = result;
    },
    isGroupColumnChange(val) {
      if (val === "yes") {
        this.ruleFormField.isSelectColumn = "yes";
      }
    },
    isAggregateColumnChange() {},
    columnTypeChange() {
      this.ruleFormField.queryMode = "";
    },
    filterGt0(prop) {
      this.ruleFormField[prop] = this.ruleFormField[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleFormField[prop] = this.ruleFormField[prop].replace(
        /^(0+)|[^\d]+/g,
        ""
      );
      this.ruleFormField[prop] = this.ruleFormField[prop].replace(
        /\.{2,}/g,
        ""
      );
    },
    handleSizeChangeAuth(size) {
      this.currentPageAuth = 1;
      this.pageSizeAuth = size;
      this.queryHasAuth();
    },
    pagingAuth(page) {
      this.currentPageAuth = page;
      this.queryHasAuth();
    },
    searchAuth() {
      this.currentPageAuth = 1;
      this.queryHasAuth();
    },
    async cancelAuth(row) {
      const result = await this.$confirm("是否确定取消授权?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });

      if (result === "confirm") {
        const { code } = await this.$store.dispatch("cancelAuth", {
          storeCode: row.storeCode,
          configId: row.configId
        });
        if (code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success"
          });
          this.queryHasAuth();
        }
      }
    },
    async searchStore() {
      const { result } = await this.$store.dispatch("getStoreByName", {
        storeName: this.filterText
      });
      if (result.length) {
        if (this.hasAuthList.length) {
          this.hasAuthList.forEach(v => {
            const index = result.findIndex(o => o.storeCode === v.storeCode);
            if (index >= 0) {
              result.splice(index, 1);
            }
          });
        }

        // result.forEach(v => {
        //   const index = this.hasAuthList.findIndex(
        //     o => o.storeCode === v.storeCode
        //   );
        //   console.warn(this.hasAuthList);
        //   console.log(v.storeCode);
        //   console.log(index);
        //
        // });

        this.allStoreNmae.push(...result);
        this.allStoreNmae = arrayUnique2(this.allStoreNmae, "storeCode");
      }
    },
    async getAllStoreCodes() {
      const { result } = await this.$store.dispatch("getAllStoreCodes");

      this.allStoreNmae = result;
    },
    async queryHasAuth() {
      let params = {
        pageNo: this.currentPageAuth,
        pageSize: this.pageSizeAuth,
        configId: this.listRow.id,
        storeName: this.storeName
      };
      const { result } = await this.$store.dispatch("queryHasAuth", params);
      const { records, total } = result;
      this.hasAuthList = records;
      this.totalAuth = total;
      // setTimeout(() => {
      //   this.$refs.tree.setCheckedKeys(result);
      // }, 100);
    },
    handleClose() {
      this.authorizeDialogVisible = false;
    },
    visibleChange(visible) {
      this.checkStrictly = !visible;
    },
    selectItem(e) {
      let expand = false;

      switch (e) {
        case "checkAll":
          this.$refs.tree.setCheckedNodes(this.allStoreNmae);
          break;
        case "cancleCheckAll":
          this.$refs.tree.setCheckedNodes([]);
          break;
        case "openAll":
          expand = true;
          break;
        case "cancleOpenAll":
          expand = false;
          break;
        default:
          break;
      }
      for (let i = 0; i < this.$refs.tree.store._getAllNodes().length; i++) {
        this.$refs.tree.store._getAllNodes()[i].expanded = expand;
      }
    },

    async savePermission() {
      const idList = this.$refs.tree.getCheckedNodes().map(v => v.storeCode);
      if (idList.length) {
        const { code } = await this.$store.dispatch("saveAuth", {
          configId: this.listRow.id,
          storeCodes: idList
        });
        if (code === "0") {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.allStoreNmae = [];
          this.filterText = "";
          this.authorizeDialogVisible = false;
          this.queryHasAuth();
          this.queryList();
        }
      } else {
        this.$message({
          message: "请选择商户",
          type: "warning"
        });
      }
    },
    addAuth() {
      this.authorizeDialogVisible = true;
    },
    async issue(row) {
      const { code } = await this.$store.dispatch("reportIssue", {
        id: row.id
      });
      if (code === "0") {
        this.$message({
          message: "操作成功",
          type: "success"
        });
        this.queryList();
      }
    },
    authorization(row) {
      this.authDialogVisible = true;
      this.listRow = row;
      this.currentPageAuth = 1;
      this.pageSizeAuth = 10;
      this.queryHasAuth();
    },
    copy(row) {
      this.listRow = row;
      this.title = "新增";
      this.type = "copy";
      this.dialogVisible = true;
      row.ssrColumnsConfigModelList.forEach(v => {
        if (v.isWhereColumn === "yes") {
          v.columnTypeName = this.columnList.find(
            o => o.itemValue === v.columnType
          ).itemText;
          v.queryModeName = this.modeList.find(
            o => o.itemValue === v.queryMode
          ).itemText;
        }
      });
      for (let key in this.ruleForm) {
        if (
          key !== "ssrColumnsConfigModelList" &&
          key !== "ssrTablesConfigModelList"
        ) {
          this.ruleForm[key] = row[key];
        }
      }
      this.ruleForm.ssrColumnsConfigModelList = [];
      row.ssrColumnsConfigModelList.forEach(v => {
        let params = {};
        for (let key in v) {
          if (
            key !== "id" &&
            key !== "configId" &&
            key !== "createTime" &&
            key !== "createBy" &&
            key !== "updateTime"
          ) {
            params[key] = v[key];
          }
        }

        this.ruleForm.ssrColumnsConfigModelList.push(params);
      });
      if (this.ruleForm.reportType === "template") {
        this.ruleForm.tableName = row.ssrTablesConfigModelList[0].tableName;
      } else {
        this.ruleForm.sqlContent = row.ssrTablesConfigModelList[0].sqlContent;
      }
      this.ruleForm.reportCode = this.ruleForm.reportCode + "_copy";
      console.log("this.ruleForm: ", this.ruleForm);
      this.ruleForm.reportName = this.ruleForm.reportName + "_复制";
      this.ruleForm.copySourceId = row.id;
    },
    template(row) {
      this.$router.push({
        name: "CustomReportTemplate",
        query: {
          id: row.id
        }
      });
    },
    details(row) {
      this.listRow = row;
      this.title = "查看";
      this.type = "details";
      this.dialogVisible = true;
      row.ssrColumnsConfigModelList.forEach(v => {
        if (v.isWhereColumn === "yes") {
          v.columnTypeName = this.columnList.find(
            o => o.itemValue === v.columnType
          ).itemText;
          v.queryModeName = this.modeList.find(
            o => o.itemValue === v.queryMode
          ).itemText;
        }
      });
      for (let key in this.ruleForm) {
        this.ruleForm[key] = row[key];
      }
      this.ruleForm.sqlContent = row.ssrTablesConfigModelList[0].sqlContent;
      this.ruleForm.sqlContentId = row.ssrTablesConfigModelList[0].id;
      this.ruleForm.targetIndexName = row.ssrTablesConfigModelList[0].targetIndexName;
      if(this.ruleForm.targetIndexName && this.ruleForm.targetIndexName.includes('*')){
        let temp = this.ruleForm.targetIndexName.split('*');
        this.ruleForm.targetIndexName = temp[0];
        this.ruleForm.targetIndexNameInput = '*';
      }else{
        this.ruleForm.targetIndexName = row.ssrTablesConfigModelList[0].targetIndexName;
        this.ruleForm.targetIndexNameInput = "";
      }
    },
    sqlContentChange() {
      if (this.type === "edit") {
        this.ruleForm.minorVersionNumModify = 1;
        this.ruleForm.isPublished =
          this.listRow.isPublished === "system" ? "system" : "edit";
      }
    },
    edit(row) {      
      this.listRow = row;
      this.dialogVisible = true;
      this.title = "编辑";
      this.type = "edit";

      row.ssrColumnsConfigModelList.forEach(v => {
        if (v.isWhereColumn === "yes") {
          v.columnTypeName = this.columnList.find(
            o => o.itemValue === v.columnType
          ).itemText;
          v.queryModeName = this.modeList.find(
            o => o.itemValue === v.queryMode
          ).itemText;
        }
      });

      for (let key in this.ruleForm) {
        this.ruleForm[key] = row[key];
      }
      if (this.ruleForm.reportType === "template") {
        this.ruleForm.tableName = row.ssrTablesConfigModelList[0].tableName;
      } else {
        this.ruleForm.sqlContent = row.ssrTablesConfigModelList[0].sqlContent;
      }
      this.ruleForm.sqlContentId = row.ssrTablesConfigModelList[0].id;
      this.ruleForm.targetIndexName = row.ssrTablesConfigModelList[0].targetIndexName;
      if(this.ruleForm.targetIndexName && this.ruleForm.targetIndexName.includes('*')){
        let temp = this.ruleForm.targetIndexName.split('*');
        this.ruleForm.targetIndexName = temp[0];
        this.ruleForm.targetIndexNameInput = '*';
      }else{
        this.ruleForm.targetIndexName = row.ssrTablesConfigModelList[0].targetIndexName;
        this.ruleForm.targetIndexNameInput = "";
      }
      if(this.ruleForm.datasourceId.includes('bbossEsStarter')){
        this.queryAllMerchant().then(res=>{
          this.targetIndexNameList = this.allMerchant.filter(v => v.indexPrefixName.indexOf(this.ruleForm.datasourceId) > -1);
        });
      }
      if(row.ssrTablesConfigModelList && row.ssrTablesConfigModelList[0].targetFieldKey){
        this.ruleForm.targetFieldKey = row.ssrTablesConfigModelList[0].targetFieldKey;
      }
    },
    async querySsrDateType() {
      const { result } = await this.$store.dispatch("querySsrDateType");
      this.dateTypeList = result;
    },
    async queryReportMode() {
      const { result } = await this.$store.dispatch("queryReportMode");
      this.modeList = result;
    },
    async queryReportColumn() {
      const { result } = await this.$store.dispatch("queryReportColumn");
      this.columnList = result;
    },
    async getParamValueAllowNull() {
      console.log("getParamValueAllowNull");
      const { code ,result } = await this.$store.dispatch("getParamValueAllowNull", {
        paramCode: "ssr_report_type_mail_desc"
      })
      if (code === "0") {
        console.log("result.paramValue",result.paramValue)
        this.paramValue = result.paramValue;
      }
    },
    editField(type, row, i) {
      this.index = i;
      this.fieldType = type;
      this.row = row;
      this.innerType = "edit";
      this.innerTitle = "编辑字段配置";
      // if (type === "ssrColumnsConfigModelList") {
      //   this.innerTitle = "编辑显示字段配置";
      // } else if (type === "searchFieldList") {
      //   this.innerTitle = "编辑查询字段配置";
      // }
      for (let key in this.ruleFormField) {
        this.ruleFormField[key] = row[key];
      }
      
      console.log("this.ruleForm: ", this.ruleForm);
      this.innerVisible = true;
    },
    addfield(type) {
      this.fieldType = type;
      this.innerType = "add";
      this.innerTitle = "新增字段配置";
      this.innerVisible = true;
      this.resetInnderRule();
    },
    submitFieldForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.ruleFormField));

          if (this.$refs.columnType) {
            params.columnTypeName = this.$refs.columnType.selectedLabel;
          }
          if (this.$refs.queryMode) {
            params.queryModeName = this.$refs.queryMode.selectedLabel;
          }
          if (this.innerType === "edit") {
            // if(this.ruleForm.ssrColumnsConfigModelList[index].columnName){

            // }
            this.ruleForm.ssrColumnsConfigModelList.forEach((v, i) => {
              if (i !== this.index) {
                if (v.columnName === params.columnName) {
                  columnFalg = true;
                }
              }
            });
            params.id = this.row.id;
          } else {
            if (this.ruleForm.ssrColumnsConfigModelList.length) {
              this.ruleForm.ssrColumnsConfigModelList.forEach(v => {
                if (v.columnName === params.columnName) {
                  columnFalg = true;
                }
              });
            }
          }
          let columnFalg = false;
          if (this.type === "edit") {
            params.isPublished = "edit";
          }
          if (columnFalg) {
            this.$message({
              message: "对应列字段名不能重复",
              type: "warning"
            });
          } else {
            if (this.innerType === "edit") {
              this.ruleForm.ssrColumnsConfigModelList[this.index] = params;
              this.ruleForm.ssrColumnsConfigModelList = [
                ...this.ruleForm.ssrColumnsConfigModelList
              ];
            } else {
              this.ruleForm.ssrColumnsConfigModelList.push(params);
            }
            this.innerVisible = false;
          }
        }
      });
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    submitRuleForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if(this.ruleForm.ssrColumnsConfigModelList && !this.ruleForm.ssrColumnsConfigModelList.length && this.ruleForm.reportType !== 'devloper'){
            this.$message({
              message: "请配置显示字段",
              type: "warning"
            }); 
            return;
          }
          let params = JSON.parse(JSON.stringify(this.ruleForm));
          if (this.type === "edit") {
            params.id = this.listRow.id;
            if (params.reportType === "template") {
              params.ssrTablesConfigModelList = [
                {
                  tableName: this.ruleForm.tableName
                }
              ];
            } else {
              params.ssrTablesConfigModelList = [
                {
                  sqlContent: this.ruleForm.sqlContent,
                  id: this.ruleForm.sqlContentId,
                  targetIndexName: this.ruleForm.targetIndexName + this.ruleForm.targetIndexNameInput,
                  targetFieldKey: this.ruleForm.targetFieldKey,
                }
              ];
            }
          } else {
            if (params.reportType === "template") {
              params.ssrTablesConfigModelList = [
                { tableName: this.ruleForm.tableName }
              ];
            } else {
              params.ssrTablesConfigModelList = [
                { 
                  sqlContent: this.ruleForm.sqlContent,
                  targetIndexName: this.ruleForm.targetIndexName + this.ruleForm.targetIndexNameInput,
                  targetFieldKey: this.ruleForm.targetFieldKey,
                }
              ];
            }
          }
          params.sysCategoryId = this.isArray(params.sysCategoryId)
            ? params.sysCategoryId[params.sysCategoryId.length - 1]
            : params.sysCategoryId;
          let name =
            this.type === "edit" ? "editSsrBasicConfig" : "addSsrBasicConfig";
          this.$store.dispatch(name, params).then(res => {
            if (res.code === "0") {
              this.dialogVisible = false;
              this.queryList();
              this.$message({
                message: "操作成功",
                type: "success"
              });
            }
          });
        }
      });
    },
    del(arr, i) {
      this.ruleForm[arr].splice(i, 1);
    },
    resetInnderRule() {
      setTimeout(() => {
        this.$refs.ruleFormField.resetFields();
        this.ruleFormField.labelName = "";
        this.ruleFormField.associatedDictCode = "";
        this.ruleFormField.columnName = "";
        this.ruleFormField.columnType = "";
        this.ruleFormField.datetimeRangeLimit = "";
        this.ruleFormField.queryMode = "";
        this.ruleFormField.isGroupColumn = "no";
        this.ruleFormField.isSelectColumn = "no";
        this.ruleFormField.isWhereColumn = "no";
        this.ruleFormField.groupSeqNum = "";
        this.ruleFormField.selectSeqNum = "";
        this.ruleFormField.whereSeqNum = "";
      }, 0);
    },
    resetRuleForm() {
      setTimeout(() => {
        this.$refs.ruleForm.resetFields();
        // this.ruleForm.reportCode = "";
        // this.ruleForm.reportName = "";
        // this.ruleForm.remark = "";
        // this.ruleForm.sqlContent = "";
        // this.ruleForm.ssrColumnsConfigModelList = [];
        // this.ruleForm.isPublished = "edit";
        for (let key in this.ruleForm) {
          if (key === "ssrColumnsConfigModelList") {
            this.ruleForm[key] = [];
          } else {
            this.ruleForm[key] = "";
          }
        }
        this.ruleForm.reportMainType = "sql";
      }, 0);
    },
    cancel() {
      this.dialogVisible = false;
    },
    add() {
      this.dialogVisible = true;
      this.title = "新增";
      this.type = "add";
      this.resetRuleForm();
    },
    async queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "querySsrBasicConfigList",
        params
      );
      const { records, total } = result;
      records.forEach(v => {
        v.publishedName = this.$sysAllDict.ssr_is_published.find(
          o => o.value === v.isPublished
        ).text;
      });
      this.list = records;
      this.total = total;
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    async queryAllMerchant() {
      this.targetIndexNameList = [];
      let clusterCode = this.ruleForm.datasourceId.split("bbossEsStarter")[1];
      clusterCode = clusterCode.replace(clusterCode[0],clusterCode[0].toLowerCase());
      const params = {
        pageNo: 1,
        pageSize: 9999,
        clusterCode
      }
      const { result } = await this.$store.dispatch(
          "mdElasticsearchIndexPrefixInfoQueryPageList",params
      );
      if(result){
      this.allMerchant = result.records;
      this.allMerchant.forEach(v=>{
        if(v && v.indexDesc && v.indexPrefixName){
          v.label = v.indexDesc + '('+ v.indexPrefixName +')'
        }else if(v && v.indexPrefixName){
          v.label = v.indexPrefixName
        }
      })
      }
    },
    remoteMethod(query) {
      if (query !== '') {
        this.targetIndexNameList = this.allMerchant.filter(v => v.indexPrefixName.indexOf(query) > -1);
      } else {
        this.targetIndexNameList = [];
      }
    },
    async sync(){
      let clusterCode = this.ruleForm.datasourceId.split("bbossEsStarter")[1];
      clusterCode = clusterCode.replace(clusterCode[0],clusterCode[0].toLowerCase());
      const params = {
        clusterCode,
      }
      const { code } = await this.$store.dispatch(
          "mdElasticsearchClusterInfoRefreshClusterInfo",params
      );
      if(code === '0'){
        this.$message({
          message: "操作成功",
          type: "success"
        });
        this.queryAllMerchant();
      }      
    },
    async queryElasticsearchDslVersion(){
      const { result } = await this.$store.dispatch('elasticsearchDslVersion');
      console.log("result:",result);
      if(result){
        this.dslList = result;
      }
    },
    
  }
};
</script>
<style lang="scss" scoped>
.is-column {
  font-size: 24px;
}
.red{
  color: red;
}
</style>
